import { Alert, Button, Card, Center, Checkbox, Loader, Stack, Text, TextInput, Title } from "@mantine/core";
import { useState } from "react";
import { useAuth } from "../lib/auth";

export function Splash({ text = "Loading…" }: { text?: string }) {
  return (
    <Center h="100vh">
      <Stack align="center">
        <img src="/logo.png" alt="PRAYOG-QP" height={72} />
        <Loader size="sm" />
        <Text c="dimmed" size="sm">{text}</Text>
      </Stack>
    </Center>
  );
}

export function AuthError({ message }: { message: string }) {
  return (
    <Center h="100vh" p="md">
      <Alert color="red" title="The PRAYOG-QP server cannot be reached" maw={480}>
        {message} Please try again in a few minutes.
      </Alert>
    </Center>
  );
}

/** Development login (the server runs with PRAYOG_AUTH_MODE=dev). Production logins go through Keycloak. */
export function DevLogin() {
  const { devLogin } = useAuth();
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [admin, setAdmin] = useState(false);
  const [organization, setOrganization] = useState("");     // as Keycloak's registration form asks (production)
  const [country, setCountry] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await devLogin(email.trim(), name.trim(), admin, organization.trim(), country.trim());
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Center h="100vh" p="md">
      <Card withBorder w={380} p="lg">
        <form onSubmit={submit}>
          <Stack>
            <Stack align="center" gap={4}>
              <img src="/logo.png" alt="" height={64} />
              <Title order={2}>PRAYOG-QP</Title>
              <Text size="sm" c="dimmed">Development login - no password</Text>
            </Stack>
            <TextInput label="E-mail" type="email" required value={email} onChange={(e) => setEmail(e.currentTarget.value)} />
            <TextInput label="Name" value={name} onChange={(e) => setName(e.currentTarget.value)} />
            <TextInput label="Organization(s) affiliated with" value={organization} onChange={(e) => setOrganization(e.currentTarget.value)} />
            <TextInput label="Country" value={country} onChange={(e) => setCountry(e.currentTarget.value)} />
            <Checkbox label="Log in as administrator" checked={admin} onChange={(e) => setAdmin(e.currentTarget.checked)} />
            {error && <Text c="red" size="sm">{error}</Text>}
            <Button type="submit" loading={busy}>Log in</Button>
          </Stack>
        </form>
      </Card>
    </Center>
  );
}
